import { getStoreWebviewParameters, isIOSDevice } from './deviceUtils';
import { THEME_QUERY_PARAM } from './urlUtils';

export enum Theme {
    LIGHT = 'light',
    DARK = 'dark',
}

export const DEFAULT_THEME = Theme.LIGHT;
export const DEFAULT_FONT_SCALE = 1.0;
export const DEVICE_DARK_THEME_SUPPORT_MEDIAQUERY = '(prefers-color-scheme: dark)';
export const DEVICE_LIGHT_THEME_SUPPORT_MEDIAQUERY = '(prefers-color-scheme: light)';

function getThemeNameFromDevice(): string | undefined {
    return window.matchMedia(DEVICE_DARK_THEME_SUPPORT_MEDIAQUERY).matches
        ? Theme.DARK
        : window.matchMedia(DEVICE_LIGHT_THEME_SUPPORT_MEDIAQUERY).matches
        ? Theme.LIGHT
        : undefined;
}

function isValidTheme(theme: string): boolean {
    return Object.values(Theme).includes(theme as Theme);
}

function getThemeNameFromKstoreCookie(): string | undefined {
    const theme = getStoreWebviewParameters()?.theme ?? '';
    return isValidTheme(theme) ? theme : undefined;
}

function getThemeNameFromQueryParam(): string | undefined {
    const queryParams = new URLSearchParams(window.location.search);
    const theme = queryParams.get(THEME_QUERY_PARAM) ?? '';
    return isValidTheme(theme) ? theme : undefined;
}

export function getThemeName(): string {
    const providedValue =
        // Prioritize theming using CSS @media queries first as they update fastest (no page reload required)
        (
            (isIOSDevice() ? getThemeNameFromDevice() : undefined) ||
            getThemeNameFromQueryParam() ||
            getThemeNameFromKstoreCookie() ||
            DEFAULT_THEME
        ).toLowerCase();

    return isValidTheme(providedValue) ? providedValue : DEFAULT_THEME;
}
